<template>
    <!-- <app-layout> -->

    <div class="w-full mx-auto flex flex-grow items-center justify-center max-w-4xl">

        <div class="bg-white sm:rounded-md border border-gray-200 px-4 py-5 sm:p-6 w-full flex flex-col gap-y-5">
            <h1 class="text-base flex items-center gap-x-4">
                <LockClosedIcon class="w-5 h-5 text-base font-bold" /> Restricted access
            </h1>
            <h2 class="font-medium text-sm">You cannot access the settings unless you are an admin.</h2>
            <h3 v-if="admins.length > 1" class="text-sm">If needed, below are the admins for your workspace:</h3>
            <h3 v-else class="text-sm">If needed, below is the admin for your workspace:</h3>
            <ul>
                <li v-for="admin in admins" :key="admin.email" class="py-1">
                    <a class="text-birdie-blue underline hover:text-blue-700 text-sm" :href="'mailto:' + admin.email"
                        title="send an email">{{ admin.name }}</a>
                </li>
            </ul>
        </div>




    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { LockClosedIcon } from "@heroicons/vue/24/solid";


export default {
    props: ["admins"],
    components: {
        AppLayout, LockClosedIcon
    },
    layout: AppLayout, // keep layout in place avoid refreshing it
    data() {
        return {
            // team_slug: this.$page.props.user.current_team.slug,
            // team_name: this.$page.props.user.current_team.name,
            mockInterval: {}
        }
    },
    created() {
        console.log(this.admins)
        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
        //console.log(this.notify_inapp_video_received)
    },
    beforeUnmount() {

    },
    mounted() {
        // const objet = { name: "Måske ønsker" }
        // console.log("objet", objet);
        // //const zep = btoa(JSON.stringify(objet));
        // const zep = btoa(unescape(encodeURIComponent(JSON.stringify(objet))));

        // console.log("zep", encodeURI(zep));

    },
    methods: {

    }
}
</script>
